<span>
    {{value|statusTimeFormat}}
</span>